/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error[_ngcontent-%COMP%]{padding:16px;color:#fff;background-color:#f44336}"];
export { styles as styles };
